import store from 'Data/store';
import getShortUrl from 'Data/services/getShortUrl';

export const getFullExplorerUrl = params => {
    const url = new URL(document.location.origin);
    const explorerParams = params;
    if (store.getState()?.device?.useMocks) explorerParams.useMocks = 'y';
    explorerParams.navmapId =
        explorerParams.navmapId || store.getState().pageState.layout.config.settings.navMapId;
    Object.keys(explorerParams).forEach(key => url.searchParams.append(key, params[key]));
    return url.href;
};

const getExplorerUrl = async (params, metadata, signal) => {
    return getShortUrl(getFullExplorerUrl(params), metadata, signal);
};

export default getExplorerUrl;
